import {Axios} from '../axios/axios.js'
//quick_match
export const quickMatchList = (e) => {
  return Axios({
    url:'/index.php/task/get_quick_task_list',
    method:"put",
    data:e
  })
}
//扫码快速新建任务 /index.php/task/quick_scan_task
export const quickMatchHandle = (e) => {
  return Axios({
    url:'/index.php/task/quick_scan_task',
    method:"put",
    data:e
  })
}
// 快速扫码分配司机 /index.php/task/quick_assigend_task

export const quickAssignedDriverHandle = (e) => {
  return Axios({
    url:'/index.php/task/quick_assigend_task',
    method:"put",
    data:e
  })
}
//取消指派司机 index.php/task/quick_unassigend_task
export const cancelAssignedDriverHandle = (e) => {
  return Axios({
    url:'/index.php/task/quick_unassigend_task',
    method:"put",
    data:e
  })
}
//删除任务 /index.php/task/quick_del_task
export const deleteTaskHandle = (e) => {
  return Axios({
    url:'/index.php/task/quick_del_task',
    method:"put",
    data:e
  })
}
//手动添加快速任务 add_quick_task
export const addQuickTaskHandle = (e) => {
  return Axios({
    url:'/index.php/task/add_quick_task',
    method:"put",
    data:e
  })
}
